import { Box } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	/** The avatar that opens a turn, or null for an equal-width spacer so a continuation row lines up under it. */
	avatar: ReactNode | null;
	/** Width (px) of the avatar column; every row of one conversation must pass the same value. */
	columnWidth: number;
	children: ReactNode;
	dataTestId?: string;
};

/** One sender-side row of a chat column: a fixed avatar column, then the bubble or card. */
export const ChatAvatarRow: FC<Props> = ({ avatar, columnWidth, children, dataTestId }) => (
	<Box data-testid={dataTestId} sx={{ display: "flex", alignItems: "flex-start", gap: 1, width: "100%" }}>
		<Box sx={{ width: columnWidth, flexShrink: 0 }}>{avatar}</Box>
		<Box sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>{children}</Box>
	</Box>
);
